<template>
  <v-card class="custom-map-card pb-2">
    <v-list-item class="card-header">
      <v-list-item-content>
        <v-list-item-title class="card-title">
          {{ title }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider class="cyan-divider"></v-divider>

    <l-map
      :style="`height: ${maxContentHeight}px; z-index:0`"
      :zoom="zoom"
      :center="mapCenter"
    >
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>

      <template v-for="(item, i) in markers">
        <l-marker
          :key="i"
          v-if="item.latitude && item.longitude"
          :lat-lng="[item.latitude, item.longitude]"
          :icon="icondiv(item)"
        />
      </template>
    </l-map>
  </v-card>
</template>

<style scoped>
/* CARD UTAMA */
.custom-map-card {
  background-color: rgba(15, 35, 70, 0.5) !important;
  color: #00ffff !important;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 255, 255, 0.15);
  overflow: hidden;
}

/* HEADER CARD */
.card-header {
  background-color: rgba(15, 35, 70, 0.5) !important;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.card-title {
  color: #00ffff !important;
  font-weight: 600;
  text-transform: uppercase;
}

/* PEMBATAS */
.cyan-divider {
  border-color: #00ffff !important;
  opacity: 0.4;
}

/* PETA */
.l-map {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  overflow: hidden;
}

.leaflet-container {
  background: #1e1e2f !important;
}

/* KONTROL LEAFLET */
.leaflet-control {
  background-color: rgba(15, 35, 70, 0.5) !important;
  color: #00ffff !important;
  border: none !important;
  border-radius: 6px !important;
  box-shadow: 0 0 6px rgba(0, 255, 255, 0.2);
}

/* POPUP LEAFLET */
.leaflet-popup-content-wrapper {
  background: #2a2a3d !important;
  color: #00ffff !important;
  border-radius: 8px;
}

.leaflet-popup-tip {
  background: #2a2a3d !important;
}

/* IKON */
.v-icon {
  color: #00ffff !important;
}
</style>

<script>
// <l-marker v-for="(item, i) in markers" :key="i" :lat-lng="[item.latitude, item.longitude]"></l-marker>
// import L from 'leaflet';
// import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import { divIcon } from "leaflet";

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
  },
  data: () => ({
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    // zoom: 15,
    // center: [51.505, -0.159],
    // markerLatLng: [51.504, -0.159],
    // markers: [{name: 'test', longitude: 107.63134002685547, latitude: -6.946066024567296}],

    showMore: false,
    rolename: "admin",
    greetingMessage: "Hello...",
    // title: 'judul'
  }),
  methods: {
    getFirstNotNull(vpositions) {
      if (vpositions.length > 0) {
        for (let i = 0; i < vpositions.length; i++) {
          let vpos = vpositions[i];
          if (vpos.latitude && vpos.longitude) {
            return vpos;
          }
        }
      }
      return null;
    },
    checkRole: function () {
      return true;
    },
    icondiv(itemData) {
      // let vhtml = this.defaultMapIcon;

      let vicon = "mdi-map-marker";
      let vcolor = "blue--text";
      if (typeof itemData.icon !== "undefined") {
        vicon = itemData.icon;
      }
      if (typeof itemData.color !== "undefined") {
        vcolor = itemData.color;
      }
      let vhtml = `<i style="font-size: 32px" class="v-icon notranslate mdi ${vicon} theme--light ${vcolor}"></i>`;
      // let vhtml = this.getMarkerHtml(this.mapMode, itemData).html;
      return divIcon({
        html: vhtml,
        // iconSize: [60, 62],
        iconSize: [38, 95],
        iconAnchor: [14, 28],
        popupAnchor: [0, -30],
        className: "myDivIcon",
      });
    },
  },
  computed: {
    maxContentHeight() {
      // return 800
      return this.height - 56;
    },
    mapCenter() {
      if (this.center) {
        return this.center;
      }
      return this.defaultMapCenter;
    },
    defaultMapCenter() {
      let result = [-6.901461, 107.618551];
      let vpoint = this.getFirstNotNull(this.markers);
      if (vpoint) {
        result = [vpoint.latitude, vpoint.longitude];
      }
      return result;
    },
  },
  created() {
    // let me = this
    console.log("map center", this.center);
  },
  props: {
    height: {
      type: Number,
      default: 500,
    },
    zoom: {
      type: Number,
      default: 16,
    },
    center: Array,
    markers: {
      type: Array,
      default: function () {
        return [
          {
            name: "Test",
            latitude: -6.901461,
            longitude: 107.618551,
          },
        ];
      },
    },
    title: {
      type: String,
      default: "Map",
    },
  },
};
</script>
